var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"14","viewBox":"0 0 24 14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 1H24","stroke":"white","stroke-width":"2"}}),_c('path',{attrs:{"d":"M0 7H24","stroke":"white","stroke-width":"2"}}),_c('path',{attrs:{"d":"M0 13H24","stroke":"white","stroke-width":"2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }